
import Toasted from 'vue-toasted'

import { useConfig } from '@/helpers/config'
import MyAdelyaContainer from './MyAdelyaContainer'
import { ErrorBus, ERROR_EVENT, FATAL_ERROR_EVENT } from './MyAdelyaEvent'

export default {
    
    install(Vue, store) {
        
        // Element root du plugin
        const root = new Vue({
            render: createElement => createElement(MyAdelyaContainer)
        })

        // Config helper
        Vue.$config = Vue.prototype.$config = useConfig()

        // Error helper
        Vue.$error = Vue.prototype.$error = message => root.$root.$emit(ERROR_EVENT, message)
        Vue.$errorPage = Vue.prototype.$errorPage = message => { ErrorBus.$emit(FATAL_ERROR_EVENT, message) }

        // Notification helper
        Vue.use(Toasted, {
            duration: 3000,
            position: 'bottom-right'
        })
        Vue.$notify = Vue.prototype.$notify = Vue.prototype.$toasted

        // Settings helper
        Vue.$setting = Vue.prototype.$setting = (KEY) => store.state.settings.current[KEY]

        // Mount root Plugin instance on new div element added to body
        root.$mount(document.body.appendChild(document.createElement('div')))
    }
}